import React from 'react';

import { ThemeContext } from 'src/providers/ThemeProvider';

export const useAppTheme = () => {
  return React.use(ThemeContext);
};
